import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import Menu from "~/ui/menu";

type Props = {
	groupId: string;
	name: string | null | undefined;
	icon: IconDefinition | string;
	add: (groupId: string | null) => void;
};

export type Item =
	| {
			icon: IconDefinition;
	  }
	| { emoji: string }
	| {};

export default function HomePanelGroupMenuItem({ groupId, icon, name, add }: Props) {
	const addToGroup = React.useCallback(() => add(groupId), [groupId, add]);

	let itemProps: Item = {};

	if (typeof icon === "string") {
		itemProps = { emoji: icon };
	} else {
		itemProps = { icon };
	}

	return (
		<Menu.RadioItem value={groupId} onSelect={addToGroup} {...itemProps}>
			{name}
		</Menu.RadioItem>
	);
}
